import { Directive, HostBinding, Input } from '@angular/core';

@Directive({ selector: '[psUiModalFooter], ps-ui-modal-footer' })
export class ModalFooterDirective {
  @HostBinding('class.modal-footer') readonly _defaultClass = true;
  @Input() position: ModalFooterPosition = 'right';

  @HostBinding('class')
  get elementClass() {
    return this.position;
  }
}

export type ModalFooterPosition = 'left' | 'center' | 'right';
